import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ContentfulDfdsService } from "../resources/contentful-dfds.service";
import { LoggingService } from "../logging.service";
import { LocaleService } from "../locale-service";
import { theme } from "@dfds-ui/theme";
import { SupportChat } from '@dfds-ui/icons/system'
import React, { useState } from 'react';
import { render } from 'react-dom'

const w = (): { jQuery: any } => window as any;

const scriptPromise = (src) =>
    new Promise((r) => {
        var e = document.createElement("script");
        e.src = src;
        e.onload = r;
        document.body.appendChild(e);
    });

const loadPuzzelScripts = async () => {
    const puzzelLatest =
        "https://chat.puzzel.com/Content/Client/js/jquery-intelecomchat.latest.min.js";
    if (!document.querySelector(`script[src="${puzzelLatest}"]`)) {
        //check if scripts have been previously loaded. Can happen if user navigates away and back
        await scriptPromise(
            "https://chat.puzzel.com/Content/Client/js/jquery-latest.min.js"
        );
        await scriptPromise(
            "https://chat.puzzel.com/Content/Client/js/jquery-intelecomchat.libs.latest.min.js"
        );
        await new Promise((r) => {
            var e = document.createElement("link");
            e.href =
                "https://chat.puzzel.com/Content/Client/css/intelecom-light.css";
            e.rel = "stylesheet";
            e.type = "text/css";
            e.onload = r;
            document.body.appendChild(e);
        });
        var style = document.createElement("style");
        style.innerHTML = `
    #chathost .intelecomchatheader { background-color: ${theme.colors.primary.main}; } 
    #chathost .intelecomchat__button { background: ${theme.colors.primary.main}; }
  `;
        document.head.appendChild(style);
    }
    //this needs to always be loaded or it will not work
    await scriptPromise(puzzelLatest);
};

//we are loading the scripts manually to minimize footprint for other users
const loadPuzzel = async (
    setShow,
    { customerKey, configurationId, queueOverride }
) => {
    if (document.querySelector("#chathost").children.length > 0) return; //chat have been loaded here. Nothing for us to do
    const feedbackButton = document.querySelector("#_hj_feedback_container div") as HTMLElement
    if (feedbackButton) feedbackButton.style['z-index'] = 50
    await loadPuzzelScripts();
    w().jQuery("#chathost").intelecomChat({
        customerKey,
        configurationId,
        chatlink: "#startchat",
        showStarter: false,
        showStarterWhenMinimized: false,
        onChatWindowShow: () => setShow(false),
        onChatWindowMinimize: () => setShow(true),
        onChatStart: (el, evt, params) => {
            const route = params.Variables.Route;
            const queueKey = (queueOverride || [])
                .map((a) => a.match(/^([A-Z]+)=>([a-z_]+)$/))
                .filter((a) => a && a[1] === route)
                .map((a) => a[2])[0];
            if (queueKey) {
                console.log('redirecting chat queue to', queueKey)
                w().jQuery("#chathost")
                    .intelecomChat("reloadOptions", { queueKey });
            }
        },
    });
    const poller = setInterval(() => {
        if (document.querySelector("#chathost").children.length > 0) {
            w().jQuery("#chathost").intelecomChat("startChat"); // this unfortunately fails if run immediately which is why we poll
            clearInterval(poller);
        }
    }, 50);
};


const LiveChat = ({
    customerKey,
    configurationId,
    queueOverride,
}) => {
    const [show, setShow] = useState(true)
    // we need to create a portal or z-index will be messed up with no way to fix it due to stacking context
    return (
        <>
            <div
                onClick={() =>
                    loadPuzzel(setShow, {
                        customerKey,
                        configurationId,
                        queueOverride,
                    })
                }
                id="startchat"
                style={{
                    position: 'fixed',
                    bottom: '2em',
                    right: '2em',
                    display: show ? 'block' : 'none',
                    zIndex: 100,
                    backgroundColor: theme.colors.primary.main,
                    borderRadius: '50%',
                    padding: '10px',
                    boxShadow: theme.elevation[4],
                    lineHeight: '10px',
                }}
            >
                <SupportChat
                    style={{
                        width: '2.1em',
                        height: '2.1em',
                        cursor: 'pointer',
                        color: theme.colors.surface.main,
                    }}
                />
            </div>
            <div id="chathost"></div>
        </>
    )
}

@Component({
    selector: "sbw-chat",
    template: "<div #react></div>",
})
export class ChatComponent implements OnInit {
    constructor(
        private contentfulDfdsService: ContentfulDfdsService,
        private logService: LoggingService,
        private localeService: LocaleService
    ) { }
    @ViewChild("react", { static: true }) react: ElementRef;

    async ngOnInit() {
        try {
            const entry = await this.contentfulDfdsService.getPuzzelChat();
            if (
                entry &&
                entry.fields.chatEnabledBookingFlow
            ) {
                render(<LiveChat {...entry.fields} />, this.react.nativeElement)
            }
        } catch {
            this.logService.logWarn({
                message: "Live chat not working on Locale: {Locale}",
                params: [this.localeService.getLocale()],
            });
        }
    }
}